{
  "nl": {
    "decision_type": {
      "actions": {
        "add_competitor": "Voeg concurrent toe",
        "add_decision_partners": "Beslissingpartner",
        "auto_share_proposals": "Goedgekeurde voorstellen automatisch delen",
        "change_rights": "Rechten wijzigen",
        "collapse": "Inklappen",
        "create_category": "Maak nieuwe categorie",
        "delete": "Verwijderen",
        "deleteMultiple": "Verwijder...",
        "delete_cancel": "Annuleren",
        "delete_group": "Verwijder partnergroep",
        "download": "Download",
        "edit": "Bewerken",
        "edit_decision_partners": "Beslissingspartners bewerken",
        "import": "Importeren",
        "manage": "Beheren",
        "new": "Nieuw",
        "newDecision": "Nieuwe beslissing",
        "newDecisions": "Beslissing",
        "save": "Opslaan",
        "show": "Toon",
        "start_new_group": "Nieuwe groep starten",
        "submit": "Opslaan"
      },
      "attributes": {
        "category": "Categorie",
        "created_at": "Aangemaakt op",
        "description": "Omschrijving",
        "name": "Titel",
        "responsible": "Verantwoordelijke",
        "start_date": "Startdatum"
      },
      "labels": {
        "add_decision_partners": "Beslissingspartners toevoegen",
        "allowCreditExplainer": "Toon minwerken voor voorstellen onder budget",
        "auto_close": "Sluit de beslissing automatisch na de deadline",
        "auto_close_info": "Door een beslissing te sluiten voorkom je dat een klant nog een voorstel aanvaardt als er geen beslissing is gemaakt. Dit is praktisch wanneer je met strikte deadlines werkt.",
        "auto_share": "Auto-delen",
        "auto_share_description": "Deel goedgekeurde voorstellen automatisch met deze partnergroep",
        "auto_share_subtitle": "Wanneer een nieuw voorstel goedgekeurd wordt",
        "auto_share_title": "Deel goedgekeurde voorstellen automatisch",
        "category_name": "Categorienaam",
        "closes_on_deadline": "Sluit na deadline",
        "createNewPartner": "Of voeg een nieuwe beslissingspartner toe",
        "decision_type_category_description": "Door een categorie, zoals keuken, badkamer, enz. toe te wijzen aan meerdere beslissingen, worden ze gegroepeerd en krijg je een beter overzicht.",
        "deleteCategory": "Categorie {category} verwijderen?",
        "deleteGroupSubtitle": "Hiermee worden alle gesprekken, voorstellen en documenten die door iedereen in {group_name} zijn aangemaakt geweest verwijderd van {decision_type_name}.",
        "deleteGroupTitle": "Je staat op het punt om {group_name} te verwijderen",
        "disclaimerDeleteGroup": "Als je {group_name} verwijdert, worden alle beslissingen voor de partners gedepubliceerd. Ja kan weer publiceren naar partners zodra deze beslissing weer partners heeft.",
        "disclamerDeleteCategory": "Als je {category} verwijdert, wordt de categorie verwijderd uit alle eraan toegewezen beslissingen. De beslissingen zelf worden niet verwijderd.",
        "editCategory": "Categorie bewerken",
        "editGroup": "Wijzig {group_name}",
        "editPartnerRights": "Wijzig communicatierechten beslissingspartner",
        "editPartnerRightsLater": "Je kan dit altijd later aanpassen",
        "edit_partner_group_eyebrow": "Partnergroep bewerken",
        "existing_groups": "Bestaande partnergroepen",
        "explainerPartners": "Voeg externe beslissingspartners toe en werk samen aan {decision_type_name}",
        "export_preparing": "Het verzamelen van alle voorstellen kan enkele minuten duren. Je ontvangt een melding wanneer jouw exportdata klaar is om te downloaden.",
        "export_proposals_approved": "Exporteer aanvaarde documenten",
        "for_decision": "Voor beslissing",
        "groupRightsWarning": "Wees gewaarschuwd! Alle gesprekken tussen de klant en de partners zullen verwijderd worden. Deze actie is onomkeerbaar. Weet u zeker dat u wilt doorgaan?",
        "hint": "Je kan jouw categorie ook aanpassen in de",
        "hintSettings": "organisatie-instellingen.",
        "last_updated_at": "Laatste update op",
        "matrix": "Statistieken",
        "new_category": "Nieuwe beslissingscategorie",
        "new_partner_group": "Nieuwe partnergroep",
        "noPartnersAddedYet": "Nog geen partners toegevoegd",
        "noResultPartner": "Geen resultaat voor {partner_name}",
        "partner_already_in_other_group": "Zit al in een andere groep",
        "partner_already_selected": "Reeds geselecteerd",
        "partner_group": "Partner Groep",
        "partner_group_footer_empty": "Selecteer minstens 1 partner",
        "partner_group_footer_summary": "{count} partner • {rights} | {count} partner • {rights} | {count} partners • {rights}",
        "partner_group_name_label": "Naam van de partnergroep",
        "partner_groups": "Partnergroepen",
        "partners": "Beslissingspartners",
        "partners_count": "Geen partners | 1 partner | {count} partners",
        "partners_in_group": "Partners in deze groep",
        "partners_in_total": "Geen partners in totaal | 1 partner in totaal | {count} partners in totaal",
        "partners_selected_count": "Geen geselecteerd | 1 geselecteerd | {count} geselecteerd",
        "permissions_label": "Groepsrechten",
        "projectUnitsTotal": "{project_name} heeft {units_count_max} units in totaal",
        "proposal_uploaded": "voorstel geüpload",
        "published_state": "Publicatiestatus",
        "searchPartners": "Zoek op naam of organisatie",
        "selectADecision": "Selecteer een beslissing",
        "select_decision_partners": "Selecteer uw beslissingspartners",
        "setUpPartners": "Voeg beslissingspartners toe",
        "set_rights": "Groepsrechten instellen voor {partner_group_name}",
        "share_existing_title": "Deel bestaande goedgekeurde voorstellen",
        "share_proposals_label": "Voorstellen delen",
        "start_date_description": "Datum enkel voor intern gebruik. Dit kan gebruikt worden om bv. te beslissen in welke volgorde beslissingen moeten worden aangemaakt door je team",
        "start_date_title": "Startdatum (optioneel)",
        "step0Title": "Welk projectsjabloon en welke beslissing wil je gebruiken?",
        "step1Title": "Welke beslissing moet de klant nemen?",
        "tab_proposal_templates": "Voorstelsjablonen",
        "tab_units": "Units",
        "upsellCategoryTypes": "Deze functie is niet inbegrepen in jouw pakket. Neem contact met ons op via de blauwe knop voor meer informatie.",
        "view": "Overzicht",
        "view_list": "Lijst",
        "view_table": "Tabel",
        "writeEmployeeNameReject": "Schrijf <i><b>{employeeName}</b></i> neer om het verwijderen te bevestigen."
      },
      "snackbars": {
        "duplicate": "De beslissing is gemaakt, maar het kopiëren vanuit de sjabloon kan een paar minuten duren."
      },
      "toasts": {
        "bulk_delete": "Beslissing successvol verwijderd | Beslissingen successvol verwijderd",
        "update": "Beslissing successvol bijgewerkt"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "'{name}' wordt al gebruikt voor dit project",
        "nameAlreadyTaken": "De titel wordt al gebruikt voor dit project",
        "needName": "Titel is verplicht",
        "projectRequired": "Selecteer eerst een project",
        "selectDecisionType": "Selecteer ten minste 1 beslissing",
        "selectSharingOption": "Selecteer met wie je de documenten wilt delen"
      }
    }
  }
}
